import * as React from "react";
import { useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import Container from "@mui/material/Container";
import { useState, useRef } from "react";
import TuneIcon from "@mui/icons-material/Tune";
import { useMediaQuery } from "react-responsive";
import { SelectField } from "../../components/InputField/SelectField";
import { SearchBar } from "../../components/InputField/SearchBar";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import { Filter } from "../../components/Modal/Filter";
import { CustomSwitch } from "../../components/Switch";

const sortBy = [
    { key: "Featured", value: "Featured" },
    { key: "Chronological", value: "Chronological" },
    { key: "Randomize", value: "Randomize" },
    { key: "Oldest-youngest", value: "Oldest-youngest" },
    { key: "Youngest-oldest", value: "Youngest-oldest" },
];

// const filterBy = [
//     { key: "abstract", value: "Abstract" },
//     { key: "collage", value: "Collage" },
//     { key: "pop art", value: "Pop Art" },
//     { key: "chip art", value: "Chip Art" },
//     { key: "water color", value: "Water Color" },
//     { key: "still life", value: "Still Life" },
//     { key: "chalk/pastels", value: "Chalk/Pastels" },
//     { key: "impressionist", value: "Impressionist" },
//     { key: "cubism", value: "Cubism" },
//     { key: "photography", value: "Photography" },
//     { key: "portraits", value: "Portraits" },
//     { key: "scratchboard", value: "Scratchboard" },
// ];

const filterBy = [
    { key: "abstract", value: "Abstract" },
    { key: "animals: bird and fish", value: "Animals: Bird and Fish" },
    { key: "animals: cats and dogs", value: "Animals: Cats and Dogs" },
    { key: "animals: general", value: "Animals: General" },
    { key: "architecture", value: "Architecture" },
    { key: "beneficial bacteria", value: "Beneficial Bacteria" },
    { key: "black and white", value: "Black and White" },
    { key: "chalk pastel", value: "Chalk Pastel" },
    { key: "chip art", value: "Chip Art" },
    { key: "chip art: art materials", value: "Chip Art: Art Materials" },
    { key: "chip art: flowers", value: "Chip Art: Flowers" },
    { key: "chip art: honored elders", value: "Chip Art: Honored Elders" },
    { key: "chip art: kids portriats", value: "Chip Art: Kids Portriats" },
    { key: "cityscapes", value: "Cityscapes" },
    { key: "collage", value: "Collage" },
    { key: "creatures", value: "Creatures" },
    { key: "cubism", value: "Cubism" },
    { key: "flowers", value: "Flowers" },
    { key: "food", value: "Food" },
    { key: "geometric", value: "Geometric" },
    { key: "impressionist", value: "Impressionist" },
    { key: "landscape", value: "Landscape" },
    { key: "mini-masterpieces", value: "Mini-Masterpieces" },
    { key: "monoprint", value: "Monoprint" },
    { key: "music", value: "Music" },
    { key: "nature", value: "Nature" },
    { key: "oil painting", value: "Oil Painting" },
    { key: "oil pastel", value: "Oil Pastel" },
    { key: "pastel hues", value: "Pastel Hues" },
    { key: "pattern", value: "Pattern" },
    { key: "people", value: "People" },
    { key: "pet portraits", value: "Pet Portraits" },
    { key: "photography", value: "Photography" },
    { key: "pop art", value: "Pop Art" },
    { key: "portraits", value: "Portraits" },
    { key: "printmaking", value: "Printmaking" },
    { key: "scratchboard", value: "Scratchboard" },
    { key: "silly city", value: "Silly City" },
    { key: "still life", value: "Still Life" },
    { key: "watercolor", value: "Watercolor" },
    { key: "winter", value: "Winter" },
    { key: "world cultures", value: "World Cultures" },
];

const grade = [
    { key: "K-2", value: "K-2" },
    { key: "3-5", value: "3-5" },
    { key: "6-8", value: "6-8" },
    { key: "9-11", value: "9-11" },
    { key: "12", value: "12" },
];

const color = [
    {
        key: "Red",
        value: (
            <Chip
                sx={{
                    backgroundColor: "#FF0000",
                    align: "right",
                    width: "50px",
                    height: "20px",
                }}
                label=""
                color="primary"
            />
        ),
    },
    {
        key: "Orange",
        value: <Chip sx={{ backgroundColor: "#FF9300", width: "50px", height: "20px" }} />,
    },
    {
        key: "Yellow",
        value: <Chip sx={{ backgroundColor: "#FFCE00", width: "50px", height: "20px" }} />,
    },
    {
        key: "Green",
        value: <Chip sx={{ backgroundColor: "#3CC100", width: "50px", height: "20px" }} />,
    },
    {
        key: "Blue",
        value: <Chip sx={{ backgroundColor: "#00A7FF", width: "50px", height: "20px" }} />,
    },
    {
        key: "Voilet",
        value: (
            <Chip
                sx={{
                    backgroundColor: "#8000FF",
                    width: "50px",
                    height: "20px",
                }}
            />
        ),
    },
    {
        key: "Pink",
        value: <Chip sx={{ backgroundColor: "#F76AEC", width: "50px", height: "20px" }} />,
    },
    {
        key: "White",
        value: <Chip sx={{ backgroundColor: "#FFFFFF", width: "50px", height: "20px" }} variant="outlined" />,
    },
    {
        key: "Grey",
        value: <Chip sx={{ backgroundColor: "#B9B9B9", width: "50px", height: "20px" }} />,
    },
    {
        key: "Black",
        value: <Chip sx={{ backgroundColor: "#000000", width: "50px", height: "20px" }} />,
    },
    {
        key: "Brown",
        value: <Chip sx={{ backgroundColor: "#A07454", width: "50px", height: "20px" }} />,
    },
];

const Header = (props) => {
    const { enableFavourite, favouriteCount, insideApplication } = props;
    const [openImageModal, setOpenImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const isDesktop = useMediaQuery({ minWidth: 1200 });
    const isMobile = useMediaQuery({ minWidth: 600 });
    const gradeRef = useRef(null);

    const [years, setYears] = useState([]);

    useEffect(() => {
        // Function to generate an array of years from a start year to the current year
        const generateYearsArray = (startYear) => {
            const currentYear = new Date().getFullYear();
            const yearsArray = [];

            for (let year = currentYear; year >= startYear; year--) {
                yearsArray.push({ key: year.toString(), value: year.toString() });
            }
            console.log(" ", yearsArray);
            return yearsArray;
        };

        // Set the state with the generated years array
        setYears(generateYearsArray(2000)); // You can specify the start year
    }, []);

    const handleChange = (record) => {
        props.onChange(record);
    };

    const handleImageDetails = (index, item) => {
        setSelectedImage(item);
        setOpenImageModal(true);
    };

    const handleClear = (event) => {
        props.onClear();
    };

    return (
        <AppBar
            sx={{
                bgcolor: "white",
                border: "2px solid black",
                borderLeft: "none",
                borderRight: "none",
                p: 0,
                mt: enableFavourite ? (isMobile ? 0 : 10) : 0,
                width: enableFavourite ? (isDesktop ? "calc(100% - 300px)" : "100%") : "100%",
                top: insideApplication ? "0px" : "99px",
            }}
            position="fixed">
            <Container sx={{ maxWidth: "100% !important" }} disableGutters>
                <Toolbar disableGutters>
                    {!isDesktop && (
                        <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "flex" }, alignItems: "center" }}>
                            <Filter
                                open={openImageModal}
                                title=""
                                onClose={() => {
                                    setOpenImageModal(false);
                                }}
                                onClear={handleClear}
                                fullScreen={true}
                                maxWidth="lg"
                                hideActions={true}
                                hideTitle={true}
                                sortBy={sortBy}
                                filterBy={filterBy}
                                grade={grade}
                                year={years}
                                color={color}
                                onChange={handleChange}
                                selectedItems={props.selectedItems}></Filter>
                            <SearchBar
                                id={"keyword"}
                                label={"Search"}
                                fullWidth
                                variant="standard"
                                InputProps={{ disableUnderline: true }}
                                value={props.selectedItems?.keyword}
                                onChange={handleChange}
                            />
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={(event) => handleImageDetails(event)}>
                                <TuneIcon sx={{ justifyContent: "flex-end" }} />
                            </IconButton>
                        </Box>
                    )}

                    {isDesktop && (
                        <Box sx={{ display: { xs: "flex", md: "flex", width: "100%" } }}>
                            <Box
                                sx={{
                                    my: 2,
                                    color: "black",
                                    display: "block",
                                    mt: 0,
                                    mb: 0,
                                    p: 0,
                                    width: "100%",
                                }}>
                                <Toolbar component="nav" variant="dense">
                                    <Box sx={{ minWidth: "14%", mr: "10px" }}>
                                        <Typography variant="subtitle">
                                            <Box
                                                sx={{
                                                    fontStyle: "italic",
                                                    fontWeight: "regular",
                                                    fontSize: "small",
                                                    mt: 1,
                                                    mb: -5,
                                                    ml: 1,
                                                    textAlign: "left",
                                                    textTransform: "capitalize",
                                                }}>
                                                Sort by:
                                            </Box>
                                        </Typography>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Box
                                                    sx={{
                                                        textTransform: "capitalize",
                                                        textAlign: "left",
                                                    }}>
                                                    <SelectField
                                                        id={"featured"}
                                                        label={"Featured"}
                                                        value={[]}
                                                        fullWidth
                                                        selectOptions={sortBy}
                                                        type={"standard"}
                                                        onChange={handleChange}
                                                        isMultiselect={false}
                                                        selectedItems={props.selectedItems?.featured}
                                                        enableFavourite={enableFavourite}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                    <Divider
                                        orientation="vertical"
                                        flexItem
                                        sx={{
                                            mr: 2,
                                            ml: 2,
                                            borderColor: "#000",
                                            borderRightWidth: 3,
                                        }}
                                    />
                                    <Box sx={{ minWidth: "14%", mr: "10px" }}>
                                        <Typography variant="subtitle">
                                            <Box
                                                sx={{
                                                    fontStyle: "italic",
                                                    fontWeight: "regular",
                                                    fontSize: "small",
                                                    mt: 1,
                                                    mb: -5,
                                                    ml: 1,
                                                    textAlign: "left",
                                                    textTransform: "capitalize",
                                                }}>
                                                Filter by
                                            </Box>
                                        </Typography>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Box
                                                    sx={{
                                                        textTransform: "capitalize",
                                                        textAlign: "left",
                                                        marginTop: "-2px",
                                                    }}>
                                                    <SelectField
                                                        fullWidth
                                                        id={"style/medium"}
                                                        label={"Style/Medium"}
                                                        value={[]}
                                                        selectOptions={filterBy}
                                                        type={"standard"}
                                                        onChange={handleChange}
                                                        isMultiselect={true}
                                                        selectedItems={props.selectedItems?.style}
                                                        enableFavourite={enableFavourite}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Box
                                        sx={{
                                            textTransform: "capitalize",
                                            textAlign: "left",
                                            minWidth: "10%",
                                            mr: "10px",
                                        }}>
                                        <SelectField
                                            fullWidth
                                            id={"grade"}
                                            label={"Grade"}
                                            value={[]}
                                            selectOptions={grade}
                                            type={"standard"}
                                            onChange={handleChange}
                                            isMultiselect={false}
                                            selectedItems={props.selectedItems?.grade}
                                            enableFavourite={enableFavourite}
                                        />
                                    </Box>
                                    <Box
                                        sx={{
                                            textTransform: "capitalize",
                                            textAlign: "left",
                                            minWidth: "10%",
                                            mr: "10px",
                                        }}>
                                        <SelectField
                                            fullWidth
                                            id={"year"}
                                            label={"Year"}
                                            value={[]}
                                            selectOptions={years}
                                            type={"standard"}
                                            onChange={handleChange}
                                            isMultiselect={false}
                                            selectedItems={props.selectedItems?.year}
                                            enableFavourite={enableFavourite}
                                        />
                                    </Box>
                                    {/* <Box
                                        sx={{
                                            textTransform: "capitalize",
                                            textAlign: "left",
                                            minWidth: "10%",
                                            mr: "10px",
                                        }}>
                                        <SelectField
                                            id={"color"}
                                            label={"Color"}
                                            value={[]}
                                            selectOptions={color}
                                            type={"standard"}
                                            onChange={handleChange}
                                            isMultiselect={true}
                                            selectedItems={props.selectedItems?.color}
                                            enableFavourite={enableFavourite}
                                        />
                                    </Box> */}
                                    <Divider
                                        orientation="vertical"
                                        flexItem
                                        sx={{
                                            mr: 2,
                                            ml: 2,
                                            borderColor: "#000",
                                            borderRightWidth: 3,
                                        }}
                                    />
                                    <Box sx={{ minWidth: "20%", mr: "10px" }}>
                                        <SearchBar
                                            id={"keyword"}
                                            label={"Search"}
                                            fullWidth
                                            value={props.selectedItems?.keyword}
                                            variant="standard"
                                            InputProps={{ disableUnderline: true }}
                                            onChange={handleChange}
                                        />
                                    </Box>

                                    {enableFavourite ? (
                                        <>
                                            <Divider
                                                orientation="vertical"
                                                flexItem
                                                sx={{
                                                    mr: 2,
                                                    ml: 2,
                                                    borderColor: "#000",
                                                    borderRightWidth: 3,
                                                }}
                                            />
                                            <CustomSwitch
                                                id={"favourite"}
                                                value={props.selectedItems?.favourite}
                                                label={
                                                    <Box sx={{ py: 0, m: 0 }}>
                                                        <Typography sx={{ p: 0, m: 0 }} variant="subtitle2" noWrap>
                                                            Your favorites
                                                        </Typography>
                                                        <Typography sx={{ p: 0, m: 0 }} variant="caption" noWrap>
                                                            {favouriteCount} selected
                                                        </Typography>
                                                    </Box>
                                                }
                                                onChange={handleChange}></CustomSwitch>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </Toolbar>
                            </Box>
                        </Box>
                    )}
                </Toolbar>
            </Container>
        </AppBar>
    );
};
export { Header };
